
export interface PhoneValidationResult {
  isValid: boolean;
  error?: string;
  formattedNumber?: string;
}

export const validatePhoneNumber = (phoneNumber: string): PhoneValidationResult => {
  if (!phoneNumber) {
    return {
      isValid: false,
      error: 'Phone number is required'
    };
  }

  // Remove all non-digit characters except +
  const cleaned = phoneNumber.replace(/[^\d+]/g, '');
  
  // Check if it starts with +
  if (!cleaned.startsWith('+')) {
    return {
      isValid: false,
      error: 'Phone number must include country code (e.g., +1 for US, +44 for UK)'
    };
  }

  // Special validation for common incorrect patterns
  if (cleaned.startsWith('+0')) {
    return {
      isValid: false,
      error: 'Invalid country code. Country codes cannot start with 0 (e.g., use +44 instead of +044)'
    };
  }

  // Check minimum length (country code + number)
  if (cleaned.length < 8) {
    return {
      isValid: false,
      error: 'Phone number is too short. Include country code and full number'
    };
  }

  // Check maximum length
  if (cleaned.length > 16) {
    return {
      isValid: false,
      error: 'Phone number is too long'
    };
  }

  // Basic format validation - should be + followed by digits
  const phoneRegex = /^\+\d{7,15}$/;
  if (!phoneRegex.test(cleaned)) {
    return {
      isValid: false,
      error: 'Invalid phone number format. Use format: +1234567890'
    };
  }

  return {
    isValid: true,
    formattedNumber: cleaned
  };
};

export const formatPhoneNumber = (phoneNumber: string): string => {
  // Remove all non-digit characters except +
  const cleaned = phoneNumber.replace(/[^\d+]/g, '');
  
  if (!cleaned.startsWith('+')) {
    return '+' + cleaned;
  }
  
  return cleaned;
};

export const getPhoneNumberExample = (countryCode: string = '+1'): string => {
  const examples: Record<string, string> = {
    '+1': '+1234567890',
    '+44': '+447123456789',
    '+33': '+33123456789',
    '+49': '+491234567890',
    '+39': '+393123456789',
    '+34': '+34123456789',
    '+31': '+31123456789',
    '+32': '+32123456789',
    '+41': '+41123456789',
    '+43': '+431234567890'
  };
  
  return examples[countryCode] || '+1234567890';
};
